import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";

export const GetColumnInfo = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `GetColumnInfo_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: `${ENDPOINT.DYNAMIC_TABLE}/column-info`,
        method: HttpMethod.GET,
      }),
  };
};
